import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
    Step,
    StepLabel,
    Stepper,
    TextField
} from "@mui/material";
import React, {useEffect, useState} from "react";
import MaterialReserveService from "../../../../../API/orders/reservation/MaterialReserveService";
import MaterialWarehouseService from "../../../../../API/orders/warehouse/material/MaterialWarehouseService";
import Box from "@mui/material/Box";

import {materialReserveChoice} from "../../../../../data/MaterialReserveState";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import SupplierTable from "../supplier/SupplierTable";
import UserSupplierMaterialService from "../../../../../API/orders/warehouse/material/UserSupplierMaterialService";
import MaterialWarehouseTableRMEU from "../material/materialwarehouse/MaterialWarehouseTableRMEU";
import TextFieldObjectWithSupplierMaterialListMaterialReserve
    from "./TextFieldObjectWithSupplierMaterialListMaterialReserve";
import ButtonBack from "../../../button/ButtonBack";
import ButtonExit from "../../../button/ButtonExit";
import ButtonAdd from "../../../button/ButtonAdd";

const steps1 = [
    'Формат резерва',
    'Выбор поставщика',
    'Тип поставки',
];

const steps2 = [
    'Формат резерва',
    'Выбор резерва',
    'Количество',
];

function getArea(length, width) {
    return length * width / 1000000;
}

function getQuantity(supplierMaterial, isSlab) {
    if (isSlab && supplierMaterial !== null) {
        let length;
        let width;
        const typeSupplierMaterial = supplierMaterial.typeSupplierMaterial;
        if (typeSupplierMaterial === "BY_FIXED_STRIPE" || typeSupplierMaterial === "WHOLE") {
            length = supplierMaterial.length;
            width = supplierMaterial.width;
        } else {
            length = supplierMaterial.length;
            width = 2070 - supplierMaterial.width;
        }
        return getArea(length, width);
    } else {
        return 0;
    }
}

function getAndSetSupplierMaterials(data, supplier, setSupplierMaterials, setQuantity,
                                    isSlab,
                                    setTypeSupplierMaterial,
                                    setSupplierMaterial) {
    const supplierMaterials = data.get(supplier.id);
    setSupplierMaterials(supplierMaterials);
    const supplierMaterial = supplierMaterials[0];
    let quantity = getQuantity(supplierMaterial, isSlab);
    setQuantity(quantity)
    setTypeSupplierMaterial(supplierMaterial.typeSupplierMaterial)
    setSupplierMaterial(supplierMaterial)
}

export const CreateSlabMaterialModal = ({
                                            open,
                                            onClose,
                                            handleCreateNewRow,
                                            id,
                                            baseCurrency,
                                            alternativeCurrency,
                                            isSlab,
                                            handleModalAlert
                                        }) => {

    const currentSlab = isSlab === "true"
    const [dataSupplierMaterials, setDataSupplierMaterials] = useState([]);
    const [dataMaterialWarehouse, setDataMaterialWarehouse] = useState([]);

    const [selectedMaterial, setSelectedMaterial] = useState(null);
    const [activeStep, setActiveStep] = useState(0)
    const [dataSuppliers, setDataSuppliers] = useState([])
    const [supplier, setSupplier] = useState(null)
    const [supplierMaterials, setSupplierMaterials] = useState(null)
    const [formatMaterialReserve, setFormatMaterialReserve] = useState(Object.entries(materialReserveChoice)[0][0])
    const materialReservesChoice = Object.entries(materialReserveChoice)
    const [steps, setSteps] = useState(steps1);
    const [quantity, setQuantity] = useState(0);
    const [typeSupplierMaterial, setTypeSupplierMaterial] = useState("WHOLE");
    const [heightField, setHeightField] = useState({height: ""});
    const [supplierMaterial, setSupplierMaterial] = useState(null);
    const [loading, setLoading] = useState(false)

    const selectMaterial = (material) => {
        setSelectedMaterial(material)
    }

    useEffect(() => {
        if (formatMaterialReserve === materialReservesChoice[0][0]) {
            setSteps(steps1);
        } else {
            setSteps(steps2);
        }
    }, [formatMaterialReserve]);

    useEffect(() => {
            MaterialWarehouseService.getAllByMaterialEstimateUnitId(id)
                .then(function (response) {
                    const data = response.data;
                    setDataMaterialWarehouse(data);
                })
                .catch(function (error) {
                    handleModalAlert(error);
                });
        }, []
    );

    useEffect(() => {
        UserSupplierMaterialService.getAllByMaterialEstimateUnit(id)
            .then(response => {
                const rawData = response.data;
                const supplierMap = new Map();
                rawData.forEach(item => {
                    const supplierKey = item.supplier.id;
                    if (!supplierMap.has(supplierKey)) {
                        supplierMap.set(supplierKey, []);
                    }
                    supplierMap.get(supplierKey).push(item);
                });
                setDataSupplierMaterials(supplierMap);
                const suppliersArray = Array.from(supplierMap.values()).map(items => items[0].supplier);
                setDataSuppliers(suppliersArray);
                setSupplier(suppliersArray[0])
                getAndSetSupplierMaterials(supplierMap, suppliersArray[0], setSupplierMaterials, setQuantity, isSlab,
                    setTypeSupplierMaterial, setSupplierMaterial);
            })
            .catch(error => {
                handleModalAlert(error);
            });
    }, [id, baseCurrency, alternativeCurrency]);

    const handleSubmit = () => {
        setLoading(true)
        const materialWarehouseId = (selectedMaterial === null || selectedMaterial === undefined) ? null : selectedMaterial.id;
        const supplierMaterialId = (supplierMaterial === null || supplierMaterial === undefined) ? null : supplierMaterial.id;
        const actualWidth = heightField?.height || null

        const currQuantity = currentSlab && formatMaterialReserve === materialReservesChoice[1][0] ? selectedMaterial?.materialPriceUnit?.quantity : quantity
        MaterialReserveService.save(id, materialWarehouseId, supplierMaterialId, currQuantity, true, true,
            true, true, actualWidth).then(function (response) {
            handleCreateNewRow(response.data);
            handleModalAlert("Данные добавлены", 'success')
            reset()

        })
            .catch(function (error) {
                handleModalAlert(error);
            })
            .finally(() => setLoading(false))
    };

    const back = () => {
        if (activeStep > 0) {
            setActiveStep(activeStep - 1);
        } else {
            onClose();
        }
    }

    const reset = () => {
        setActiveStep(0)
        onClose()
        selectMaterial(null)
    }

    const selectSupplier = (supplier) => {
        setSupplier(supplier)
        getAndSetSupplierMaterials(dataSupplierMaterials, supplier,
            setSupplierMaterials, setQuantity, isSlab,
            setTypeSupplierMaterial,
            setSupplierMaterial);
    }

    const submit = () => {
        if (activeStep < 2) {
            setActiveStep(activeStep + 1);
        } else {
            handleSubmit();
        }
    }

    const handleChange = (event) => {
        setSelectedMaterial(null)
        setFormatMaterialReserve(event.target.value);
    };

    const handleChangeSupplierMaterial = (id) => {
        const foundMaterial = supplierMaterials.find(material => material.id.toString() === id);
        let quantity = getQuantity(foundMaterial, isSlab);
        setQuantity(quantity)
        setTypeSupplierMaterial(foundMaterial.typeSupplierMaterial)
        setSupplierMaterial(foundMaterial)
    }

    const handleChangeWidth = (value) => {
        setHeightField(value)
    }

    return (
        <Dialog open={open} PaperProps={{
            style: {
                minWidth: `${activeStep === 1 ? "1410px" : "700px"}`,
                height: `${activeStep === 1 ? "700px" : "470px"}`,
            }
        }}>
            <DialogTitle textAlign="center">Добавить резерв</DialogTitle>
            <DialogContent sx={{paddingBottom: 0}}>
                <Stepper activeStep={activeStep} alternativeLabel>
                    {steps.map((label) => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
                <Box style={{
                    height: 24,
                    marginTop: 30,
                    padding: 2,
                    display: "flex",
                    alignItems: "center",
                    border: !currentSlab && formatMaterialReserve === materialReservesChoice[1][0] ? "none" : supplier ? activeStep === 1 ? formatMaterialReserve === materialReservesChoice[0][0]
                        ? "blue 1px solid" : (selectedMaterial !== null && selectedMaterial !== undefined ? "blue 1px solid"
                            : "transparent 1px solid") : "transparent 1px solid" : "transparent 1px solid"
                }}>
                    {((currentSlab && activeStep !== 0) || (!currentSlab && formatMaterialReserve === materialReservesChoice[0][0] && activeStep !== 0)) &&
                        <Box
                            style={{marginRight: 40}}>
                            {formatMaterialReserve === materialReservesChoice[0][0] &&
                            activeStep === 1 && supplier !== null
                            && supplier !== undefined ? supplier.name : (selectedMaterial !== null && selectedMaterial !== undefined ?
                                    isSlab ? "[" + selectedMaterial.materialPriceUnit.length + "x" +
                                        +selectedMaterial.materialPriceUnit.width + "] количество " + selectedMaterial.materialPriceUnit.quantity + " свободно " + selectedMaterial.freeQuantity
                                        : " количество " + selectedMaterial.materialPriceUnit.quantity + " свободно " + selectedMaterial.freeQuantity
                                    : ""
                            )}</Box>}
                </Box>
                {activeStep === 0 ?
                    <Box style={{display: "flex", flexDirection: "column"}}>

                        <RadioGroup
                            defaultValue="female"
                            aria-labelledby="demo-customized-radios"
                            name="customized-radios"
                            onChange={handleChange}
                            value={formatMaterialReserve}
                        >
                            {materialReservesChoice.map((option) => (
                                    <FormControlLabel
                                        value={option[0]}
                                        control={<Radio/>}
                                        label={option[1]}
                                        sx={{
                                            minWidth: "400px",
                                            height: "36px",
                                            "&:not(:last-of-type)": {
                                                marginBottom: "4px",
                                            },
                                            borderBottom: (theme) => `${theme.palette.primary.stroke} solid 1px`,
                                            "&:hover": {
                                                backgroundColor: (theme) => theme.palette.primary.light
                                            }
                                        }
                                        }
                                    />
                                )
                            )}
                        </RadioGroup>

                    </Box>
                    : activeStep === 1 ?
                        <Box>
                            {formatMaterialReserve === materialReservesChoice[0][0] ? <SupplierTable
                                data={dataSuppliers}
                                selectId={supplier?.id}
                                select={selectSupplier}
                            /> : <MaterialWarehouseTableRMEU
                                data={dataMaterialWarehouse}
                                selectedMaterial={selectedMaterial}
                                selectMaterial={selectMaterial}
                                currentSlab={currentSlab}
                            />}
                        </Box> :

                        <Stack
                            sx={{
                                width: '100%',
                                minWidth: {xs: '300px', sm: '360px', md: '400px'},
                                gap: '0.01rem',
                            }}
                        >
                            {currentSlab && <TextFieldObjectWithSupplierMaterialListMaterialReserve
                                label="Тип поставки"
                                field={'supplierMaterialId'}
                                setId={handleChangeSupplierMaterial}
                                entityList={supplierMaterials}
                                name={'typeSupplierMaterial'}
                                typeSupplierMaterial={typeSupplierMaterial}
                            />}
                            {typeSupplierMaterial === "BY_MIN_STRIPE" && <TextField
                                size={"small"}
                                sx={{
                                    width: '100%',
                                    minWidth: {xs: '300px', sm: '360px', md: '400px'},
                                    gap: '1.5rem',
                                }}
                                margin="normal"
                                key={'height'}
                                label={"Высота"}
                                name={'height'}
                                disabled={currentSlab && typeSupplierMaterial === "BY_FIXED_STRIPE" || currentSlab && typeSupplierMaterial === "WHOLE"}
                                value={heightField?.height}
                                onChange={(e) => {
                                    let area = getArea(2800, e.target.value);
                                    setQuantity(area);
                                    handleChangeWidth({...heightField, [e.target.name]: e.target.value})
                                }}
                            />}
                            <TextField
                                size={"small"}
                                sx={{
                                    width: '100%',
                                    minWidth: {xs: '300px', sm: '360px', md: '400px'},
                                    gap: '1.5rem',
                                }}
                                margin="normal"
                                key={'quantity'}
                                label={"Количество"}
                                name={'quantity'}
                                type={"number"}
                                disabled={currentSlab}
                                value={quantity}
                                onChange={(e) => setQuantity(e.target.value)}
                            />
                        </Stack>

                }
            </DialogContent>

            <DialogActions style={{padding: 40, display: "flex", justifyContent: "space-between"}}>
                <Box>{activeStep !== 0 && <ButtonBack text={"Назад"} onClick={back}/>} </Box>
                <Box>
                    <ButtonExit text={"Выйти"} onClick={reset}/>
                    <ButtonAdd
                        loading={loading}
                        text={"Выбрать"} onClick={submit}
                        disabled={activeStep === 2 && supplierMaterial == null}/>
                </Box>
            </DialogActions>
        </Dialog>
    );
}
export default CreateSlabMaterialModal